import { render, staticRenderFns } from "./BarcodeRequest.vue?vue&type=template&id=24e9aab2&"
import script from "./BarcodeRequest.vue?vue&type=script&lang=js&"
export * from "./BarcodeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports